import AlertPopup from "components/alert-popup/AlertPopup";
import MissionBillsTable from "components/form/mission/MissionBillsTable";
import InfoContext from "pages/InfoContext";
import MissionBillingForm from "components/form/mission/MissionBillingForm";
import MissionFeeForm from "components/form/mission/MissionFeeForm";
import MissionRTTForm from "components/form/mission/MissionRTTForm";
import { POPUP_STATUS } from "constants/constants";
import { useContext, useEffect, useState } from "react";
import propTypes from "prop-types";

const MissionBillingInfo = ({
  clearErrors,
  control,
  errors,
  register,
  setValue,
  unregister,
  watch,
  readOnly,
  sirenErrorMessage,
  mission_fee,
}) => {
  const [code, setCode] = useState();
  const [status, setStatus] = useState();
  const { missionById } = useContext(InfoContext);

  useEffect(() => {
    if (sirenErrorMessage) {
      setStatus(POPUP_STATUS.ERROR);
      setCode(sirenErrorMessage);
    }
  }, [sirenErrorMessage]);

  return (
    <>
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <MissionBillingForm
        missionBySlug={missionById}
        missionCurrentFee={mission_fee}
        readOnly={readOnly}
        setValue={(field, value) => {
          setValue(field, value);
          clearErrors(field);
        }}
        watch={watch}
        control={control}
        register={register}
        errors={errors}
        clearErrors={clearErrors}
      />
      {missionById?.id && !readOnly && (
        <MissionBillsTable setValue={setValue} />
      )}
      <MissionFeeForm
        readOnly={readOnly}
        setValue={(field, value) => {
          setValue(field, value);
          clearErrors(field);
        }}
        watch={watch}
        control={control}
        register={register}
        errors={errors}
        clearErrors={clearErrors}
        unregister={unregister}
      />
      <MissionRTTForm
        readOnly={readOnly}
        setValue={(field, value) => {
          setValue(field, value);
          clearErrors(field);
        }}
        watch={watch}
      />
    </>
  );
};

export default MissionBillingInfo;

MissionBillingInfo.propTypes = {
  clearErrors: propTypes.func,
  control: propTypes.object,
  errors: propTypes.object,
  register: propTypes.func,
  setValue: propTypes.func,
  unregister: propTypes.func,
  watch: propTypes.func,
  readOnly: propTypes.bool,
  sirenErrorMessage: propTypes.string,
  mission_fee: propTypes.object,
};
